import EthicAndCompliancePage from 'screens/EthicAndCompliance/EthicAndCompliance';

export default EthicAndCompliancePage;
